module.exports = __webpack_public_path__ + "img/medicine-dog.001fc15a.png";